import styled from "styled-components";
import { ReactComponent as Pen } from "../../../../assets/icons/pen.svg";
import { ReactComponent as Trash } from "../../../../assets/icons/trash.svg";
import { Drawer } from "antd";
export const Wrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #e5e5e5;
  padding: 60px 60px 50px 90px;
`;
Wrap.Drawer = styled(Drawer)``;

Wrap.Title = styled.h1`
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #0d263b;
`;

Wrap.Backin = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 1px;
  color: #696969;
`;

Wrap.Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  margin-top: 60px;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  padding: 30px;
`;
Wrap.Table = styled.table`
  margin-top: 30px;
`;
Wrap.Label = styled.label`
  display: flex;
  align-items: center;
`;

Wrap.Order = styled.select`
  border: none;
  font-weight: 400;
  font-size: 14px;
  outline: none;
  line-height: 18px;
  color: #696969;
`;
Wrap.Filter = styled.select`
  border: none;
  font-weight: 400;
  font-size: 14px;
  outline: none;
  line-height: 18px;
  color: #696969;
`;
Wrap.Search = styled.input`
  min-width: 100px;
  border: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  outline: none;
  padding-bottom: 8px;
  border-bottom: 1px solid #e6e9ec;
  margin-left: auto;
`;

Wrap.Wrap = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  margin-right: 30px;
  border-bottom: 2px solid #e6e9ec;
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #0d263b;
  }
`;

Wrap.Thead = styled.thead`
  background: #e6e9ec;
  border-radius: 3px;
  .listing-title {
    padding-left: 20px;
  }
`;

Wrap.Tr = styled.tr`
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 0.5fr;
  align-items: center;
  padding: 20px 0;
`;

Wrap.Td = styled.td`
  display: flex;
  align-items: center;
  position: relative;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;

  .date {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #696969;
  }
  .pending {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #cc5040;
  }
  .view {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #696969;
  }
`;

Wrap.Tbody = styled.tbody`
  display: flex;
  flex-direction: column;
`;

Wrap.Img = styled.img`
  width: 160px;
  height: 140px;
`;

Wrap.ImgBtn = styled.div`
  position: absolute;
  top: 12px;
  left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 73px;
  height: 23px;
  background: #0061df;
  border-radius: 3px;
  margin: 0px 10px;
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  color: #ffffff;
`;

Wrap.Details = styled.div`
  margin: 20px;
  .fsale {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-decoration-line: line-through;
    color: #696969;
  }
  .sale {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #0d263b;
  }
`;

Wrap.DetailsTitle = styled.h1`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 71px;
    height: 23px;
    background: #0d263b;
    font-weight: 600;
    font-size: 10px;
    line-height: 13px;
    color: #ffffff;
    border-radius: 3px;
    margin: 0px 10px;
  }
`;

Wrap.DetailsDescrpt = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
`;

Wrap.Pen = styled(Pen)`
  width: 16px;
  cursor: pointer;
  height: 16px;
`;
Wrap.Trash = styled(Trash)`
  width: 35px;
  height: 35px;
  background: #f6f8f9;
  border-radius: 50%;
  padding: 9px;
  margin-left: 20px;
  cursor: pointer;
`;

Wrap.Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-pagination-item-link {
    border: none;
  }
  .ant-pagination li {
    border: none !important;
  }
  .ant-pagination li:hover:not(.ant-pagination-item-active) {
    border-radius: 50%;
    background-color: #f6f8f9;
    a {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .ant-pagination-item-active {
    background: #0061df;
    border-radius: 50%;
    a {
      color: #fff !important;
    }
  }
`;
